import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    buttonBox: {
        display: "flex",
        justifyContent: "flex-end",
        gap: theme.spacing(1),
    },
    tagsBox: {
        overflowY: "auto",
        maxWidth: 400,
        maxHeight: 70,
        display: "flex",
        flexWrap: "wrap",
        gap: theme.spacing(1),
        padding: theme.spacing(1),
    },
    link: {
        textDecoration: "underline",
    },
    isUploading: {
        backgroundColor: theme.palette.emteria.border.primary,
    },
    tableRow: {
        "&:hover": {
            backgroundColor: theme.palette.emteria.background.listHover,
        },
    },
    visibilitySelect: {
        width: 250,
        backgroundColor: "inherit",

        "& .MuiOutlinedInput-input": {
            fontSize: 16,
            padding: theme.spacing(1, 4),
        },
    },
}));

export const getLastTableRowStyle = (index: number, length: number) => {
    return index === length - 1 ? { paddingBottom: 10 } : {};
};
